import React, { FC } from 'react';
import {
  AtlassianIcon,
  BitbucketIcon,
  CompassIcon,
  ConfluenceIcon,
  JiraIcon,
  JiraServiceManagementIcon,
  OpsgenieIcon,
  StatuspageIcon,
  TrelloIcon,
  LogoProps,
  LoomIcon,
  GuardIcon,
  JiraAlignIcon,
  JiraProductDiscoveryIcon,
  RovoIcon,
  RovoDevIcon,
  BambooIcon,
  CrowdIcon,
  BitbucketDataCenterIcon,
  JiraServiceManagementDataCenterIcon,
  ConfluenceDataCenterIcon,
  JiraDataCenterIcon,
} from '@atlaskit/logo';
import { MarketingIcon } from './icons';

interface OwnProps {
  title: string;
}

type IconType =
  | 'confluenceDataCenter'
  | 'jsmDataCenter'
  | 'bitbucketDataCenter'
  | 'crowd'
  | 'jiraDataCenter'
  | 'bamboo'
  | 'rovo'
  | 'rovoDev'
  | 'jiraProductDiscovery'
  | 'jira'
  | 'jsm'
  | 'confluence'
  | 'bitbucket'
  | 'trello'
  | 'statuspage'
  | 'opsgenie'
  | 'jiraAlign'
  | 'compass'
  | 'marketing'
  | 'guard'
  | 'loom'
  | 'atlassian';

const titleToIconType: Record<string, IconType> = {
  // Confluence Data Center
  productUpgradesConfluenceDataCenter: 'confluenceDataCenter',
  productRecommendationsConfluenceDataCenter: 'confluenceDataCenter',

  // JSM Data Center
  productUpgradesJiraServiceDeskDataCenter: 'jsmDataCenter',
  productRecommendationsJiraServiceDeskDataCenter: 'jsmDataCenter',

  // Bitbucket Data Center
  productUpgradesBitbucketDataCenter: 'bitbucketDataCenter',
  productRecommendationsBitbucketDataCenter: 'bitbucketDataCenter',

  // Crowd
  crowdTechAlerts: 'crowd',
  productUpgradesCrowdDataCenter: 'crowd',
  productRecommendationsCrowdDataCenter: 'crowd',

  // Jira Data Center
  productRecommendationsJiraCoreDataCenter: 'jiraDataCenter',
  productUpgradesJiraCoreDataCenter: 'jiraDataCenter',
  productRecommendationsJiraSoftwareDataCenter: 'jiraDataCenter',
  productUpgradesJiraSoftwareDataCenter: 'jiraDataCenter',

  // Bamboo
  bambooTechAlerts: 'bamboo',

  // Rovo
  productRecommendationsRovoCloud: 'rovo',

  // Rovo Dev
  productRecommendationsRovoDev: 'rovoDev',
  productUpgradesRovoDev: 'rovoDev',

  // Jira Product Discovery
  productRecommendationsJiraProductDiscoveryCloud: 'jiraProductDiscovery',
  productUpgradesJiraProductDiscoveryCloud: 'jiraProductDiscovery',

  // Jira
  jiraMacApp: 'jira',
  automationForJiraProductRecommendationsCloud: 'jira',
  automationForJiraProductUpgradesCloud: 'jira',
  automationForJiraTipsAndTricksCloud: 'jira',
  automationForJiraProductRecommendationsServer: 'jira',
  iconsForJiraProductRecommendationsServer: 'jira',
  automationForJiraProductUpgradesServer: 'jira',
  iconsForJiraProductUpgradesServer: 'jira',
  automationForJiraTipsAndTricksServer: 'jira',
  iconsForJiraTipsAndTricksServer: 'jira',
  productRecommendationsAdvancedRoadmapsForJiraCloud: 'jira',
  productRecommendationsJiraSoftwareCloud: 'jira',
  productUpgradesAdvancedRoadmapsForJiraCloud: 'jira',
  productUpgradesJiraSoftwareCloud: 'jira',
  jiraSoftwareTechAlerts: 'jira',
  jiraCloudCSComms: 'jira',
  jiraServerNewsletter: 'jira',
  jiraSoftwareProductRecommendationsCloud: 'jira',
  jiraSoftwareProductRecommendationsServer: 'jira',
  jiraSoftwareProductUpgradesCloud: 'jira',
  jiraSoftwareProductUpgradesServer: 'jira',
  jiraSoftwareTipsAndTricksCloud: 'jira',
  jiraSoftwareTipsAndTricksServer: 'jira',
  productUpgradesJiraSoftwareServer: 'jira',
  productRecommendationsJiraSoftwareServer: 'jira',
  jiraOps: 'jira',
  jiraCoreTechAlerts: 'jira',
  jiraCoreProductRecommendationsCloud: 'jira',
  jiraCoreProductRecommendationsServer: 'jira',
  jiraCoreProductUpgradesCloud: 'jira',
  jiraCoreTipsAndTricksCloud: 'jira',
  productRecommendationsJiraCoreCloud: 'jira',
  productRecommendationsJiraCoreServer: 'jira',
  productUpgradesJiraCoreCloud: 'jira',
  productUpgradesJiraCoreServer: 'jira',

  // JSM
  jiraServiceDeskTechAlerts: 'jsm',
  jiraServiceDeskProductRecommendationsCloud: 'jsm',
  jiraServiceDeskProductRecommendationsServer: 'jsm',
  jiraServiceDeskProductUpgradesCloud: 'jsm',
  jiraServiceDeskProductUpgradesServer: 'jsm',
  jiraServiceDeskTipsAndTricksCloud: 'jsm',
  jiraServiceDeskTipsAndTricksServer: 'jsm',
  jsmCloudCSComms: 'jsm',
  productRecommendationsJiraServiceDeskCloud: 'jsm',
  productRecommendationsJiraServiceDeskServer: 'jsm',
  productUpgradesJiraServiceDeskCloud: 'jsm',
  productUpgradesJiraServiceDeskServer: 'jsm',

  // Confluence
  confluenceCloudCSComms: 'confluence',
  confluenceInsidersNewsletter: 'confluence',
  confluenceTechAlerts: 'confluence',
  confluenceProductRecommendationsCloud: 'confluence',
  confluenceProductRecommendationsServer: 'confluence',
  confluenceProductUpgradesCloud: 'confluence',
  confluenceProductUpgradesServer: 'confluence',
  confluenceTipsAndTricksCloud: 'confluence',
  confluenceTipsAndTricksServer: 'confluence',
  analyticsForConfluenceAppProductRecommendationsServer: 'confluence',
  productRecommendationsConfluenceCloud: 'confluence',
  productRecommendationsConfluenceServer: 'confluence',
  productUpgradesConfluenceCloud: 'confluence',
  productUpgradesConfluenceServer: 'confluence',

  // Bitbucket
  bitbucketTechAlerts: 'bitbucket',
  bitbucketProductRecommendationsCloud: 'bitbucket',
  bitbucketProductRecommendationsServer: 'bitbucket',
  bitbucketProductUpgradesCloud: 'bitbucket',
  bitbucketProductUpgradesServer: 'bitbucket',
  bitbucketTipsAndTricksCloud: 'bitbucket',
  bitbucketTipsAndTricksServer: 'bitbucket',
  productUpgradesBitbucketCloud: 'bitbucket',
  productUpgradesBitbucketServer: 'bitbucket',
  productRecommendationsBitbucketCloud: 'bitbucket',
  productRecommendationsBitbucketServer: 'bitbucket',

  // Trello
  trelloCSComms: 'trello',
  trelloProductRecommendationsCloud: 'trello',
  trelloPowerUpsProductRecommendationsCloud: 'trello',
  trelloProductUpgradesCloud: 'trello',
  trelloPowerUpsProductUpgradesCloud: 'trello',
  trelloTipsAndTricksCloud: 'trello',
  trelloPowerUpsTipsAndTricksCloud: 'trello',
  productUpgradesTrello: 'trello',
  productRecommendationsTrello: 'trello',
  trelloNewsletter: 'trello',
  trelloEnterprise: 'trello',

  // Statuspage
  statuspageProductRecommendationsCloud: 'statuspage',
  statuspageProductUpgradesCloud: 'statuspage',
  statuspageTipsAndTricksCloud: 'statuspage',
  productRecommendationsStatuspageCloud: 'statuspage',
  productUpgradesStatuspageCloud: 'statuspage',

  // Opsgenie
  opsgenieProductRecommendationsCloud: 'opsgenie',
  opsgenieProductUpgradesCloud: 'opsgenie',
  opsgenieTipsAndTricksCloud: 'opsgenie',
  opsgenieOnboarding: 'opsgenie',
  productRecommendationsOpsgenieCloud: 'opsgenie',
  productUpgradesOpsgenieCloud: 'opsgenie',

  // Jira Align
  jiraAlignProductRecommendationsCloud: 'jiraAlign',
  jiraAlignProductUpgradesCloud: 'jiraAlign',
  jiraAlignTipsAndTricksCloud: 'jiraAlign',
  productRecommendationsJiraAlignCloud: 'jiraAlign',
  productRecommendationsJiraAlignDataCenter: 'jiraAlign',
  productRecommendationsJiraAlignServer: 'jiraAlign',
  productUpgradesJiraAlignCloud: 'jiraAlign',
  productUpgradesJiraAlignDataCenter: 'jiraAlign',
  productUpgradesJiraAlignServer: 'jiraAlign',

  // Compass
  compassDigest: 'compass',
  compassNewsletter: 'compass',
  productRecommendationsCompassCloud: 'compass',
  productUpgradesCompassCloud: 'compass',

  // Marketing
  generalMarketingOptIn: 'marketing',

  // Guard
  beaconNewsletter: 'guard',
  productRecommendationsAtlassianAccess: 'guard',
  productUpgradesAtlassianAccess: 'guard',

  // Loom
  loomProductEngagements: 'loom',
  loomReplayNewsletter: 'loom',
  productRecommendationsLoomCloud: 'loom',
  productUpgradesLoomCloud: 'loom',
  loomCloudCSComms: 'loom',
};

const defaultProps: LogoProps = {
  size: 'xlarge',
  appearance: 'brand',
  shouldUseNewLogoDesign: true,
};

const iconFactories: Record<IconType, () => JSX.Element> = {
  confluenceDataCenter: () => <ConfluenceDataCenterIcon {...defaultProps} testId='confluence-data-center-icon' />,
  jsmDataCenter: () => <JiraServiceManagementDataCenterIcon {...defaultProps} testId='jsm-data-center-icon' />,
  bitbucketDataCenter: () => <BitbucketDataCenterIcon {...defaultProps} testId='bitbucket-data-center-icon' />,
  crowd: () => <CrowdIcon {...defaultProps} testId='crowd-icon' />,
  jiraDataCenter: () => <JiraDataCenterIcon {...defaultProps} testId='jira-data-center-icon' />,
  bamboo: () => <BambooIcon {...defaultProps} testId='bamboo-icon' />,
  rovo: () => <RovoIcon {...defaultProps} testId='rovo-icon' />,
  rovoDev: () => <RovoDevIcon {...defaultProps} testId='rovo-dev-icon' />,
  jiraProductDiscovery: () => <JiraProductDiscoveryIcon {...defaultProps} testId='jira-product-discovery-icon' />,
  jira: () => <JiraIcon {...defaultProps} testId='jira-icon' />,
  jsm: () => <JiraServiceManagementIcon {...defaultProps} testId='jira-service-management-icon' />,
  confluence: () => <ConfluenceIcon {...defaultProps} testId='confluence-icon' />,
  bitbucket: () => <BitbucketIcon {...defaultProps} testId='bitbucket-icon' />,
  trello: () => <TrelloIcon {...defaultProps} testId='trello-icon' />,
  statuspage: () => <StatuspageIcon {...defaultProps} testId='statuspage-icon' />,
  opsgenie: () => <OpsgenieIcon {...defaultProps} testId='opsgenie-icon' />,
  jiraAlign: () => <JiraAlignIcon {...defaultProps} testId='jira-align-icon' />,
  compass: () => <CompassIcon {...defaultProps} testId='compass-icon' />,
  marketing: () => <MarketingIcon data-testid='marketing-icon' />,
  guard: () => <GuardIcon {...defaultProps} testId='atlassian-guard-icon' />,
  loom: () => <LoomIcon {...defaultProps} testId='loom-icon' />,
  atlassian: () => <AtlassianIcon {...defaultProps} testId='atlassian-icon' />,
};

const ItemIcon: FC<OwnProps> = ({ title }) => {
  const iconType = titleToIconType[title] || 'atlassian';
  return iconFactories[iconType]();
};

export default ItemIcon;
